<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <div v-if="!isLoading && dataList.length" class="wrap">
          <ul class="my-reserve-wrap">
            <div v-for="(data, index) in dataList" :key="index">
              <li v-if="index%2 === 0">
                  <reservation-alarm-list :data="dataList[index]"/>
                  <reservation-alarm-list :data="dataList[index+1]"/>
              </li>
            </div>
          </ul>
          <paging-component :current-page="currentPage" :page-count="totalCount" :limit="limit"
                            :paging-count="pagingCnt" wrapper-class="paging-type02" />
        </div>
        <div v-if="!isLoading && dataList.length === 0" class="my-reserve-empty">
          <empty-list text="시청예약 내역이 없어요."></empty-list>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ReservationAlarmList from '@/components/mypooq/ReservationAlarmList'
import PagingComponent from '@/components/common/PagingComponent'
import { getAlarmsContent } from '@/common/utils/request'
import EmptyList from '@/components/mypooq/EmptyList'
import { scrollTop } from '@/common/utils/common'
import _ from 'lodash'
export default {
  components: {
    ReservationAlarmList,
    PagingComponent,
    EmptyList
  },
  data () {
    return {
      dataList: [],
      orderby: 'new',
      currentPage: 1,
      pagingCnt: 10,
      limit: 10,
      totalCount: 0,
      isLoading: true
    }
  },
  methods: {
    url (url) {
      return location.protocol + '//' + url
    },
    setData () {
      scrollTop()
      this.isLoading = true
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      let offset = this.limit * (this.currentPage - 1)
      getAlarmsContent({ contenttype: 'live', offset, limit: this.limit }).then(({ data }) => {
        this.dataList = _.get(data, 'list', [])
        this.totalCount = Number(_.get(data, 'pagecount', '1'))
        this.isLoading = false
        if (this.dataList.length === 0 && offset !== 0 && this.currentPage !== 1) {
          this.$router.push({
            name: 'reserve_watch',
            query: {
              page: this.currentPage - 1
            }
          })
        }
      })
    }
  },
  created () {
    this.setData()
  }
}
</script>
